import { render, staticRenderFns } from "./MedicalCertTemplate.vue?vue&type=template&id=7d2f4e28&scoped=true"
import script from "./MedicalCertTemplate.vue?vue&type=script&lang=js"
export * from "./MedicalCertTemplate.vue?vue&type=script&lang=js"
import style0 from "./MedicalCertTemplate.vue?vue&type=style&index=0&id=7d2f4e28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d2f4e28",
  null
  
)

export default component.exports